import { z } from 'zod';
export const createAudienceExecutionResultSchema = z.object({
    audienceId: z.string().uuid(),
});
export const createCampaignDraftExecutionResultSchema = z.object({
    campaignId: z.string().uuid(),
});
//# sourceMappingURL=results.js.map